(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["decopot-distributor-finder"] && !Shopify.designMode) return;
  try {
    
  class DecopotDistributorFinder {
    constructor(container) {
      this.container = container;
      this.searchInput = container.querySelector(".ddf-search-input");
      this.count = container.querySelector("[data-results-count]");
      this.emptyState = container.querySelector("[data-empty-state]");
      this.regionList = container.querySelector("[data-region-list]");
      this.filterButtons = [...container.querySelectorAll(".ddf-filter-button")];
      this.cards = [...container.querySelectorAll("[data-distributor-card]")];
      this.bindEvents();
      this.render();
    }

    normalise(value) {
      return String(value || "").toLowerCase().trim();
    }

    bindEvents() {
      this.filterButtons.forEach((button) => {
        button.addEventListener("click", () => {
          this.searchInput.value = button.dataset.filter || "";
          this.render();
          this.searchInput.focus();
        });
      });

      this.searchInput.addEventListener("input", () => this.render());
    }

    renderRegions(cards) {
      const regions = cards.reduce((summary, card) => {
        const region = card.dataset.region || "Other";
        summary[region] = (summary[region] || 0) + 1;
        return summary;
      }, {});

      this.regionList.innerHTML = Object.entries(regions)
        .sort(([first], [second]) => first.localeCompare(second))
        .map(([region, total]) => `
          <div class="ddf-region-item">
            <span class="ddf-region-name">${region}</span>
            <span>${total} ${total === 1 ? "distributor" : "distributors"}</span>
          </div>
        `)
        .join("");
    }

    updateActiveFilter(query) {
      this.filterButtons.forEach((button) => {
        this.normalise(button.dataset.filter) === this.normalise(query)
          ? button.classList.add("is-active")
          : button.classList.remove("is-active");
      });
    }

    render() {
      const query = this.normalise(this.searchInput.value);
      const matches = this.cards.filter((card) => this.normalise(card.dataset.search).includes(query));

      this.cards.forEach((card) => {
        card.hidden = !matches.includes(card);
      });
      this.count.textContent = `${matches.length} ${matches.length === 1 ? "result" : "results"}`;
      this.emptyState.style.display = matches.length ? "none" : "block";
      this.renderRegions(matches.length ? matches : this.cards);
      this.updateActiveFilter(query);
    }
  }

  function initDecopotDistributorFinders() {
    document.querySelectorAll(".decopot-distributor-finder").forEach((container) => {
      if (!container.dataset.distributorFinderReady) {
        container.dataset.distributorFinderReady = "true";
        new DecopotDistributorFinder(container);
      }
    });
  }

  initDecopotDistributorFinders();

  document.addEventListener("shopify:section:load", initDecopotDistributorFinders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["decopot-faq"] && !Shopify.designMode) return;
  try {
    
  class DecopotFaq {
    constructor(container) {
      this.container = container;
      this.searchInput = container.querySelector(".df-search-input");
      this.count = container.querySelector("[data-results-count]");
      this.emptyState = container.querySelector("[data-empty-state]");
      this.filterButtons = [...container.querySelectorAll(".df-filter-button")];
      this.items = [...container.querySelectorAll("[data-faq-item]")];
      this.bindEvents();
      this.render();
    }

    normalise(value) {
      return String(value || "").toLowerCase().trim();
    }

    bindEvents() {
      this.filterButtons.forEach((button) => {
        button.addEventListener("click", () => {
          this.searchInput.value = button.dataset.filter || "";
          this.render();
          this.searchInput.focus();
        });
      });

      this.searchInput.addEventListener("input", () => this.render());
    }

    updateActiveFilter(query) {
      this.filterButtons.forEach((button) => {
        this.normalise(button.dataset.filter) === this.normalise(query)
          ? button.classList.add("is-active")
          : button.classList.remove("is-active");
      });
    }

    render() {
      const query = this.normalise(this.searchInput.value);
      const matches = this.items.filter((item) => this.normalise(item.dataset.search).includes(query));

      this.items.forEach((item) => {
        item.hidden = !matches.includes(item);
        if (!matches.includes(item)) {
          item.open = false;
        }
      });
      this.count.textContent = `${matches.length} ${matches.length === 1 ? "answer" : "answers"}`;
      this.emptyState.style.display = matches.length ? "none" : "block";
      this.updateActiveFilter(query);
    }
  }

  function initDecopotFaqs() {
    document.querySelectorAll(".decopot-faq").forEach((container) => {
      if (!container.dataset.faqReady) {
        container.dataset.faqReady = "true";
        new DecopotFaq(container);
      }
    });
  }

  initDecopotFaqs();

  document.addEventListener("shopify:section:load", initDecopotFaqs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
